import { useState } from 'react';

const BRAND = 'linear-gradient(150deg,#6E50F0,#3F27B0)';

export default function IntroCarousel({ slides, onClose }) {
  const [slide, setSlide] = useState(0);
  const isLast = slide === slides.length - 1;
  const current = slides[slide];
  const SlideIcon = current.Icon;
  const isMobile = window.innerWidth < 1024;

  return (
    <div className="fixed inset-0 z-50 font-sans select-none flex items-center justify-center"
      style={{
        background: isMobile ? 'white' : 'rgba(0,0,0,0.4)',
        paddingTop: isMobile ? 'env(safe-area-inset-top)' : 0,
      }}>

      <div className="bg-white flex flex-col w-full"
        style={{
          height: isMobile ? '100%' : 'auto',
          maxWidth: isMobile ? '100%' : 480,
          borderRadius: isMobile ? 0 : 20,
          overflow: 'hidden',
          boxShadow: isMobile ? 'none' : '0 8px 40px rgba(33,28,43,0.18)',
          paddingTop: isMobile ? 'env(safe-area-inset-top)' : 0,
        }}>

        {/* Pular */}
        <div className="flex justify-end px-5 pt-4 flex-shrink-0">
          <button onClick={onClose}
            className="text-[13px] text-ink-400 font-medium py-1 px-2 bg-transparent border-0 cursor-pointer">
            Pular
          </button>
        </div>

        {/* Conteúdo */}
        <div className="flex-1 flex flex-col items-center justify-center px-8 text-center"
          style={{ minHeight: isMobile ? 0 : 340 }}>
          {SlideIcon
            ? <div className="mb-6 w-[88px] h-[88px] rounded-[28px] flex items-center justify-center" style={{background:'linear-gradient(150deg,#EDE9FF,#D8D0FF)'}}><SlideIcon size={44} strokeWidth={1.4} color="#5B3CE4" /></div>
            : <div className="text-[80px] mb-6 leading-none">{current.emoji}</div>
          }
          <h2 className="text-[24px] font-extrabold text-ink-900 mb-3 leading-tight">
            {current.titulo}
          </h2>
          <p className="text-[15px] text-ink-500 leading-relaxed max-w-xs">
            {current.descricao}
          </p>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mb-6 flex-shrink-0">
          {slides.map((_, i) => (
            <div key={i} className="h-2 rounded-full transition-all duration-300"
              style={{
                width: i === slide ? 24 : 8,
                background: i === slide ? '#5B3CE4' : '#EAE5DC',
              }} />
          ))}
        </div>

        {/* Botão */}
        <div className="flex-shrink-0 px-5"
          style={{ paddingBottom: isMobile ? 'calc(32px + env(safe-area-inset-bottom))' : 32 }}>
          <button
            onClick={isLast ? onClose : () => setSlide(s => s + 1)}
            className="w-full py-3.5 rounded-[14px] text-white font-bold text-[15px] border-0 cursor-pointer"
            style={{ background: BRAND }}>
            {isLast ? 'Entendi!' : 'Próximo →'}
          </button>
        </div>
      </div>
    </div>
  );
}
